import React, { useMemo } from 'react'

import { PageTitle } from '@vividseats/vivid-ui-kit'

interface TitleProps {
    title: string
}

const Title: React.FC<TitleProps> = ({ title }) => {
    // Append ' Tickets' to title if title doesn't end with it
    const ticketsTitle: string = useMemo(() => (/ Tickets$/i.test(title) ? title : `${title} Tickets`), [title])

    return <PageTitle title={ticketsTitle} />
}

export default Title
